import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

import { HostsSearch } from '../inputs/hosts_search'
import { OwnersSearch } from '../inputs/owners_search'
import { PermissionSelector } from '../inputs/permission_selector'
import { UsersSearch } from '../inputs/users_search'

export const AllUsersScope = ({
  selectedHostIds, setSelectedHostIds,
  selectedOwnerIds, setSelectedOwnerIds,
  selectedUserIds, setSelectedUserIds,
  selectedPermission, setSelectedPermission
}) => (
  <>
    <BodyText>
      {I18n.t('publisher.event_types.filters.description.personal')}
    </BodyText>
    <HostsSearch selectedIds={selectedHostIds} setSelectedIds={setSelectedHostIds} />
    <OwnersSearch selectedIds={selectedOwnerIds} setSelectedIds={setSelectedOwnerIds} />
    <UsersSearch selectedIds={selectedUserIds} setSelectedIds={setSelectedUserIds} />
    <PermissionSelector
      value={selectedPermission}
      onChange={setSelectedPermission}
      indent
    />
  </>
)
